var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.47473 14.0425C3.3648 14.0425 0.0214844 10.8972 0.0214844 7.03059C0.0214844 3.16402 3.3648 0.0186768 7.47473 0.0186768C11.5847 0.0186768 14.928 3.16402 14.928 7.03059C14.928 8.53559 14.4215 9.93132 13.5604 11.0748L16.6218 13.9608C17.1285 14.4385 17.1285 15.2105 16.6218 15.6881C16.3692 15.9264 16.0374 16.0461 15.7057 16.0461C15.3739 16.0461 15.0422 15.9264 14.7895 15.6881L11.7179 12.7926C10.5129 13.5804 9.05013 14.0425 7.47473 14.0425ZM7.47512 2.02226C4.5396 2.02226 2.15137 4.26908 2.15137 7.03077C2.15137 9.79246 4.5396 12.0393 7.47512 12.0393C10.4106 12.0393 12.7989 9.79246 12.7989 7.03077C12.7989 4.26908 10.4106 2.02226 7.47512 2.02226Z",
    fill: "#94A3B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.016c67381590203c708635a1ab1f6bb4.svg";
export { ForwardRef as ReactComponent };